import ErrorHandler from './ErrorHandler';
import Authenticator from '../protocol/Authenticator';
import { Logger } from '../logger/Logger';
import NotificationController from '../controllers/NotificationController';
import BackgroundJobRunner from '../util/runner/BackgroundJobRunner';
import t from '../i18n/I18n';

export default {
  // eslint-disable-next-line no-unused-vars
  handleError(error, defaultMsg = null, onlyLogMsg, ignoreRendering, onErrorCallBack = undefined) {
    let __errorStatusCode;
    let infoError = null;
    if (error) {
      console.error(error);
      if (typeof error === 'string') {
        infoError = error.toString();
      } else if (typeof error === 'object' && typeof error.errorMsg === 'string') {
        infoError = error.errorMsg;
      } else {
        __errorStatusCode = error.status;
        if (__errorStatusCode === undefined) __errorStatusCode = error.errorId;

        let __errorMsg = null;
        if (Number.isInteger(__errorStatusCode) && __errorStatusCode > 0) {
          __errorMsg = ErrorHandler.parseErrorCode(__errorStatusCode);
        }

        if (__errorMsg == null && error.errorDetails !== undefined && error.errorDetails.length > 0) {
          __errorMsg = error.errorDetails;
        }

        if (__errorMsg === null) {
          __errorMsg = ErrorHandler.extractErrorMsg(error.statusText);
          if (!__errorMsg) __errorMsg = defaultMsg == null ? t('UNKNOWN_ERROR') : defaultMsg;
        }

        if (!__errorMsg) {
          if (typeof error === 'object' && error.errorDetails !== undefined && error.errorDetails.length > 0) {
            __errorMsg = error.errorDetails;
          }
        }

        infoError = __errorMsg;
      }
    }

    if (onlyLogMsg) {
      ErrorHandler.logger.error(infoError);
      infoError = undefined;
    }

    if (ErrorHandler.isAuthRelatedError(__errorStatusCode)) {
      NotificationController.getInstance().clearTimer();
      BackgroundJobRunner.JOB_RUNNER.pause('Pausing timer because of auth errors.');
    }
    this.displayErrorMsg(infoError, onErrorCallBack);
  },

  displayErrorMsg(infoError, onErrorCallBack) {
    if (!window.setError) {
      setTimeout(() => {
        this.displayErrorMsg(infoError, onErrorCallBack);
      }, 200);
    } else {
      window.setError(infoError);
      window.gs.onErrorCallBack = onErrorCallBack;
      window.render();
    }
  },

  extractErrorMsg(text) {
    let __returnMsg;
    if (text) {
      if (typeof text !== 'string' && !(text instanceof String)) {
        if (typeof text === 'object') {
          if (text.hasOwnProperty('errorMsg') && typeof text.errorMsg === 'string')
            text = text.errorMsg;
          else if (text.hasOwnProperty('message') && typeof text.message === 'string')
            text = text.message;
          else
            text = String(text);
        } else {
          text = String(text);
        }
      }
      let si = text.indexOf(ErrorHandler.ERROR_START_TAG);
      let ei = text.indexOf(ErrorHandler.ERROR_END_TAG);
      if (si !== -1 && ei !== -1) {
        const subSt = text.substring(si + ErrorHandler.ERROR_START_TAG.length, ei);
        const actualMessageArr = subSt.split(ErrorHandler.SPLIT_TAG);
        if (actualMessageArr && actualMessageArr.length > 2) {
          __returnMsg = actualMessageArr[2];
        }
      } else {
        si = text.indexOf(ErrorHandler.TITLE_TAG);
        ei = text.indexOf('</title>');
        if (si !== -1 && ei !== -1) {
          __returnMsg = text.substring(si + ErrorHandler.TITLE_TAG.length, ei);
        }
      }
      if (!__returnMsg) {
        __returnMsg = text;
      }
      __returnMsg = ErrorHandler.unescapeXMLEncoding(__returnMsg);
    }

    return __returnMsg;
  },

  /**
   * Jetty performs XML-escaping for HTML response as well as JSON message strings. So, need to unescape the XML-escaped characters.
   * @param str{string}
   * @return {String}
   */
  unescapeXMLEncoding(str: string) {
    return !str ? str : String(str).replace(/&gt;/g, ">").replace(/&lt;/g, "<").replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/&amp;/g, "&");
  },


  parseErrorCode(__errorStatusCode) {
    let __returnMsg = null;
    switch (__errorStatusCode) {
      case 401:
        __returnMsg = t('AUTH_FAILED');
        break;
      case 402:
        __returnMsg = t('AUTH_FAILED');
        break;
      case 403:
        __returnMsg = t('SERVER_NOT_RESPONDING');
        break;
      case 404:
        __returnMsg = Authenticator.AUTH_DATA.serverUrl
          ? t('FAILED_CONNECT_SERVER', { ERROR: Authenticator.AUTH_DATA.serverUrl })
          : t('SERVER_NOT_RESPONDING');
        break;
      case 405:
        __returnMsg = t('ACCESS_DENIED', { USER: Authenticator.AUTH_DATA.username });
        break;
      case 406:
        __returnMsg = t('AUTH_FAILED');
        break;
      case 409:
        __returnMsg = t('ACCESS_DENIED', { USER: Authenticator.AUTH_DATA.username });
        break;
      case 411:
        __returnMsg = t('REPOID_MISMATCH');
        break;
      case 500:
        __returnMsg = t('INTERNAL_SERVER_ERROR');
        break;
    }

    return __returnMsg;
  },

  isAuthRelatedError(__errorStatusCode) {
    if (__errorStatusCode) {
      if (__errorStatusCode >= 401 && __errorStatusCode <= 414) return true;
    }
    return false;
  }
};

ErrorHandler.logger = new Logger('ErrorHandler');

ErrorHandler.ERROR_START_TAG = '__ERROR_START__';
ErrorHandler.TITLE_TAG = '<title>';
ErrorHandler.ERROR_END_TAG = '__ERROR_END__';
ErrorHandler.SPLIT_TAG = '__:__';
